export default __webpack_public_path__ + "static/media/banned-account.0820adaa.png";